<template>
  <div>
    <vs-prompt
      title="Select product to add"
      @cancel="val = ''"
      @accept="accept"
      :active.sync="prompt"
      accept-text="Add product"
      :is-valid="validForm"
      class="add-order-product-popup"
    >
      <div class="data-list-container data-list-list-view">
        <vs-table
          v-if="filteredProducts"
          ref="table"
          class="mt-8"
          pagination
          search
          maxItems="6"
          v-model="selectedProduct"
          :data="filteredProducts"
          noDataText="No data"
        >
          <template slot="thead">
            <vs-th sort-key="number">Number</vs-th>
            <vs-th sort-key="stockProductName">Name</vs-th>
            <vs-th sort-key="isMandatoryProduct">Mandatory</vs-th>
            <vs-th sort-key="venueStockAmount">Stock vs desired</vs-th>
            <vs-th sort-key="neededQuantity">Stock deficit</vs-th>
            <vs-th sort-key="unitPrice">Unit cost</vs-th>
            <vs-th sort-key="caseSize">Case size</vs-th>
            <vs-th sort-key="orderCases">Cases to order</vs-th>
            <vs-th sort-key="linePrice">Line price</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <div
                    class="
                      product-name
                      font-medium
                      truncate
                      flex flex-row
                      items-center
                    "
                  >
                    <img width="40" :src="ProductIcon" />
                    <p class="ml-4">{{ tr.stockProductId.id }}</p>
                  </div>
                </vs-td>
                <vs-td :data="tr.stockProductName">
                  <div v-if="tr.stockProductName">
                    {{ tr.stockProductName }}
                  </div>
                  <div v-else>
                    <vs-chip> No name </vs-chip>
                  </div>
                </vs-td>
                <vs-td :data="tr.isMandatoryProduct">
                  <vs-chip>
                    {{ tr.isMandatoryProduct | yesno }}
                  </vs-chip>
                </vs-td>
                <vs-td :data="tr.venueStockAmount">
                  <code class="whitespace-no-wrap">
                    {{ tr.venueStockAmount }}
                    <span>/</span>
                    {{ tr.venueDesiredStockAmount }}
                  </code>
                  <div>
                    <small>({{ tr.currentStockLevelPercentage }} %)</small>
                  </div>
                </vs-td>
                <vs-td :data="tr.neededQuantity">
                  <vs-chip :color="tr.neededQuantity > 0 ? 'danger' : ''">
                    {{ tr.neededQuantity }}
                  </vs-chip>
                </vs-td>
                <vs-td :data="tr.unitPrice">
                  {{ tr.unitPrice }}
                </vs-td>
                <vs-td :data="tr.caseSize">
                  {{ tr.caseSize }}
                </vs-td>
                <vs-td :data="tr.orderCases">
                  {{ tr.orderCases }}
                </vs-td>
                <vs-td :data="tr.linePrice">
                  <vx-tooltip
                    :text="`Calculated as: ${tr.caseSize} * ${tr.unitPrice} * ${tr.orderCases} = ${tr.linePrice}`"
                  >
                    <b>{{ tr.linePrice | numberFormatDK }}</b>
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProductIcon from "@/assets/images/product-icon.png";
export default {
  data() {
    return {
      moment,
      ProductIcon,

      prompt: false,
      selectedProduct: null,

      eligibleProductsInfo: null,
    };
  },
  props: {
    existingProducts: {
      type: Array,
      default: () => [],
    },
    venueOrderLines: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.selectedProduct != null;
    },

    // Filter out products already in the booking form
    filteredProducts() {
      console.log("Eligible products", this.venueOrderLines);

      if (!this.venueOrderLines) {
        return [];
      }

      return this.venueOrderLines.filter((e) => {
        return !this.existingProducts.some(
          (p) => p.stockProductId.id === e.stockProductId.id
        );
      });
    },
  },
  methods: {
    async show() {
      // dispatch eligible products
      this.prompt = true;
    },
    async accept() {
      this.$emit("productSelected", this.selectedProduct);
    },
  },
};
</script>

<style lang="scss">
.add-order-product-popup {
  z-index: 52011;

  .vs-dialog {
    max-width: 1200px;

    .vs-dialog-text {
      background-color: #f8f8f8;
    }

    .header-table.vs-table--header {
      margin-left: 0 !important;
    }
  }
}
</style>
